export const environment = {
    production: true,
    API_URL: 'http://104.248.140.123/api',
};
